import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=73e4413c&"
import script from "./VerticalMenu.js?vue&type=script&lang=js&"
export * from "./VerticalMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports